import { Popper as MUIPopper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Popper = styled(MUIPopper, {
  shouldForwardProp: prop => prop !== 'autoWidth',
})(({ autoWidth }) => ({
  width: autoWidth ? 'fit-content !important' : 'auto',
}));
